import { RoutePath, type RoutePaths } from "@/lib/routes"

export const externalRoutesPaths = {
    backOfficeB2BG: RoutePath.create("https://backoffice.unergie.com/b2g-home-v2"),
    ecoSessionWhatsApp: RoutePath.create(
        "https://www.whatsapp.com/channel/0029VbB3wgRBKfi8asEYwE1V"
    ),
    welcomeToTheJungle: RoutePath.create(
        "https://www.welcometothejungle.com/fr/companies/octopus-energy"
    ),
    cnil: RoutePath.create("https://www.cnil.fr/"),
    energyChequeEligibility: RoutePath.create(
        "https://guichet.chequeenergie.gouv.fr/guichetchq/verifier-mon-eligibilite"
    ),
    energyChequeUsage: RoutePath.create(
        "https://chequeenergie.gouv.fr/beneficiaire/cheque/utiliser-mon-cheque"
    ),
    octopusTypeform: RoutePath.create("https://octopus.typeform.com/to/:formId"),
    social: {
        youtube: RoutePath.create("https://www.youtube.com/@OctopusEnergyFr"),
        instagram: RoutePath.create("https://www.instagram.com/octopusenergyfr/"),
        facebook: RoutePath.create("https://www.facebook.com/OctopusEnergyFr"),
        tiktok: RoutePath.create("https://www.tiktok.com/@octopusenergyfr"),
        x: RoutePath.create("https://x.com/OctopusEnergyFr"),
    },
} as const satisfies RoutePaths
